import cn from 'classnames'
import uniqueId from 'lodash/uniqueId'
import React, { FC, MutableRefObject } from 'react'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import styles from '@root-gipro/shared/Table/styles/Table.module.scss'
import Tooltip from '@material-ui/core/Tooltip'
import { Cells } from '@root-gipro/modules/userProjects/components/Project/UncTable/Cells'
import {
	BodyType,
	gridTemplateColumnsAreaCalculation,
	theadCAreaCalculation,
} from '@root-gipro/modules/userProjects/models/consts/unc-thead.const'
import { IUnc } from '@root-gipro/store/interfaces'

interface RowCellsProps {
	title: string
	uncs: IUnc[]
	uncsFiltered: IUnc[]
	tableNum: number
	currentCellTags: string
	voltageRef: MutableRefObject<undefined | string>
	isArchived?: boolean
	checkedTable: number
	currentUncSort: string | null
}

export const RowCells: FC<RowCellsProps> = ({
	voltageRef,
	uncs,
	uncsFiltered,
	tableNum,
	currentCellTags,
	isArchived,
	checkedTable,
	currentUncSort,
}) => {
	const filtered = uncsFiltered.filter((unc) => checkedTable === 6 || unc.tableNum === checkedTable)

	return (
		<>
			{tableNum === 8 && uncs.length > 0 && (
				<div
					style={{ gridTemplateColumns: gridTemplateColumnsAreaCalculation, gap: '8px' }}
					className={cn(styles.thead, styles.grid)}
				>
					{theadCAreaCalculation.map((item: BodyType) => (
						<Tooltip key={uniqueId('unc_')} title={item.tooltip} enterDelay={500} enterNextDelay={500} placement='top'>
							<div className={cn(styles.theadCell)}>{item.title}</div>
						</Tooltip>
					))}
				</div>
			)}

			{filtered.length > 0 ? (
				<SortableContext items={filtered.map((u) => u.id.toString())} strategy={verticalListSortingStrategy}>
					<div className='table-row-container' style={{ position: 'relative' }}>
						{filtered.map((elem, ind, arr) => (
							<Cells
								uncs={arr}
								index={ind}
								key={elem.id}
								unc={elem}
								currentUncSort={currentUncSort}
								currentCellTags={currentCellTags}
								voltageRef={voltageRef}
								tableNum={tableNum}
								isArchived={isArchived}
								checkedTable={checkedTable}
							/>
						))}
					</div>
				</SortableContext>
			) : (
				<div className={styles.nothing}>Нет данных</div>
			)}
		</>
	)
} // end
